import { render, staticRenderFns } from "./actor-message.vue?vue&type=template&id=8cf6f058&scoped=true&"
import script from "./actor-message.vue?vue&type=script&lang=ts&"
export * from "./actor-message.vue?vue&type=script&lang=ts&"
import style0 from "./actor-message.vue?vue&type=style&index=0&id=8cf6f058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf6f058",
  null
  
)

export default component.exports